<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="addActivity">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <!-- <el-form-item label="活动状态">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item> -->
      <el-form-item class="search-form-item">
        <el-input v-model="search.title" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="计划ID" width="100" fixed />
      <el-table-column prop="title" label="训练计划标题" width="auto" fixed />
      <el-table-column prop="objectId" label="关联活动ID" width="100" fixed>
        <template #default="{row}">
          <span v-if="row.objectId">{{ row.objectId }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="关联活动状态" align="center" width="auto">
        <template v-slot="{row}">
          <el-tag v-if="row.status" :style="{'color':statusList.find(item=>item.id == row.status).color,'borderColor':statusList.find(item=>item.id == row.status).borderColor,'backgroundColor':statusList.find(item=>item.id == row.status).bgColor}" class="" size="mini">{{ statusList.find(item=>item.id == row.status).value }}</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" label="创建时间" width="auto">
        <template #default="{row}">
          {{ $moment(row.beginTime).format('YYYY/MM/DD hh:mm:ss')|| '--' }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="500" label="操作">
        <template v-slot="{row}">
          <el-button v-if="row.status != 5" size="small" type="text" class="link-color" @click="editActivity(row)">编辑</el-button>
          <el-button v-if="row.status == 5" size="small" type="text" class="link-color" @click="previewActivity(row)">查看</el-button>
          <el-button size="small" type="text" class="link-color" @click="copyActivity(row)">复制</el-button>
          <el-button v-if="!row.status" size="small" type="text" class="link-color" @click="delActivity(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
export default {
  components: { Dialog },
  data() {
    const statusList = [
      { id: 1, value: '草稿', color: '#EA9921', borderColor: '#ea9921b3', bgColor: '#ea99211a' },
      { id: 2, value: '已发布', color: '#60AC56', borderColor: '#60ac56b3', bgColor: '#60ac561a' },
      { id: 3, value: '进行中', color: '#1890FF', borderColor: '#1890ffb3', bgColor: '#1890ff1a' },
      { id: 4, value: '已结束', color: '#9B9B9B', borderColor: '#9b9b9bb3', bgColor: '#9b9b9b1a' },
      { id: 5, value: '已下架', color: '#9B9B9B', borderColor: '#9b9b9bb3', bgColor: '#9b9b9b1a' },
    ];
    return {
      statusList,
      search: {
        title: "",
      },
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      currentID: -1,
      formDialogShow: false,
      information: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    searchSubmit() {
      this.getList();
    },
    reset() {
      this.search = { title: '' };
      this.currentPage.current = 1;
      this.getList();
    },
    getList() {
      this.$Api.newCamp.planList({ ...this.search, ...this.currentPage }).then(res => {
        if (res) {
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    editActivity(row) {
      this.openDialog(row, {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑活动ID为“${row.id}”的数据项？`,
      });
    },
    copyActivity(row) {
      this.openDialog(row, {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      });
    },
    previewActivity(row) {
      this.$router.push({ path: `/online_activity/plan/edit`, query: { id: row.id, type: 'preview', status: row.status } });
    },
    submitSuccess(operation) {
      if (operation === 'delete') {
        this.$Api.newCamp.deletePlan(this.currentID).then(data => {
          this.$message.success('删除成功');
          this.getList();
        });
      } else if (operation === 'copy' || operation === 'edit') {
        this.$router.push({ path: `/online_activity/plan/edit`, query: { id: this.currentID, type: operation, status: this.currentStatus } });
      } else {
        this.$router.push({ path: `/online_activity/plan/add`, query: { id: this.currentID, type: operation } });
      }
    },
    addActivity() {
      this.$router.push({ path: '/online_activity/plan/add' });
    },
    delActivity(row) {
      this.openDialog(row, {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否确认删除活动ID为“${row.id}”的数据项？`,
      });
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
    openDialog(row, { operation, icon, subTitle }) {
      this.formDialogShow = true;
      row && (this.currentID = row.id);
      row && (this.currentStatus = row.status);
      this.information = { operation, icon, subTitle };
    },
  },
};
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 580px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 20px 30px 30px;
      .upload-wrap {
        width: 100%;
        height: 236px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}

.el-pagination {
  padding-left: 30px;
}
</style>
